module.exports = __webpack_public_path__ + "img/reset-password.3dee7335.jpeg";